import { render, staticRenderFns } from "./LoadingField.vue?vue&type=template&id=280bd6a4"
import script from "./LoadingField.vue?vue&type=script&lang=js"
export * from "./LoadingField.vue?vue&type=script&lang=js"
import style0 from "./LoadingField.vue?vue&type=style&index=0&id=280bd6a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports